// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"94":"d181cd84","595":"a591ee78","883":"517dd73a"}[chunkId] + ".chunk.css";
};